import styled from 'styled-components'
export const Sliderdiv = styled.div`
  justify-content: center;
`
export const BannerImage = styled.img`
  cursor: pointer;
`
